import { services } from '../services';
var action = "project";

export const projectService = {
    getList,
    getOne,
    insert,
    update,
    remove,
    sumary
};

function getList(param = '') {
    return services.restApi(`${action}${param}`, 'GET');
}

function getOne(id) {
    return services.restApi(`${action}/${id}`, 'GET');
}

function sumary(id, version = 100) {
    return services.restApi(`${action}/sumary/${id}/${version}`, 'GET');
}

function insert(object) {
    return services.restApi(`${action}`, 'POST', object);
}

function update(id, object) {
    return services.restApi(`${action}/${id}`, 'PUT', object);
}

function remove(id) {
    return services.restApi(`${action}/${id}`, 'DELETE');
}